import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import OpenApp from '../views/openApp.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/app',
    name: 'openApp',
    component: OpenApp
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
